(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if (!customElements.get('tays-stock-first')) {
  customElements.define('tays-stock-first', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.order()); }
    disconnectedCallback() { this.request?.abort(); }
    async order() {
      const root = this.closest('#ProductGridContainer');
      const grid = root?.querySelector('ul#product-grid');
      const url = new URL(location.href);
      if (url.searchParams.has('tays_artist')) return;
      const chosen = url.searchParams.getAll('filter.v.availability').flatMap(v => v.split(',')).filter(Boolean);
      const total = Number(this.dataset.total);
      const available = Number(this.dataset.available);
      const size = Number(this.dataset.size);
      const page = Math.max(1, Number(url.searchParams.get('page') || this.dataset.page || 1));
      if (!grid || this.dataset.known !== 'true' || !size || (chosen.length === 1)) return;
      this.hidden = false;
      if (available === 0 || available === total) {
        this.textContent = available ? 'Stokta olan ürünler gösteriliyor.' : 'Bu listedeki ürünler şu anda tükenmiş durumda.';
        this.dataset.state = 'ready';
        return;
      }
      // Keep the same notice height while cards are fetched; aria-busy signals loading.
      this.textContent = 'Stokta olan ürünler önce, tükenenler son sayfalarda gösterilir.';
      this.dataset.state = 'loading';
      root.setAttribute('aria-busy', 'true');
      root.classList.add('tays-stock-loading');
      this.request = new AbortController();
      const timer = setTimeout(() => this.request.abort(), 15000);
      try {
        let cards;
        if (total <= size) {
          cards = [...grid.children].sort((a, b) => Number(b.dataset.productAvailable === 'true') - Number(a.dataset.productAvailable === 'true'));
        } else {
          const offset = (page - 1) * size;
          const inCount = Math.max(0, Math.min(size, available - offset));
          const outCount = Math.min(size - inCount, Math.max(0, total - Math.max(offset, available)));
          const spans = [];
          if (inCount) spans.push(this.span(url, '1', offset, inCount, size, available));
          if (outCount) spans.push(this.span(url, '0', Math.max(0, offset - available), outCount, size, total - available));
          cards = (await Promise.all(spans)).flat();
          if (cards.length !== Math.min(size, total - offset)) throw new Error('Product count changed');
        }
        if (!this.isConnected) return;
        grid.replaceChildren(...cards);
        this.textContent = 'Stokta olan ürünler önce, tükenenler son sayfalarda gösterilir.';
        this.dataset.state = 'ready';
      } catch (error) {
        if (!this.isConnected) return;
        this.textContent = 'Stok sıralaması yüklenemedi. ';
        this.dataset.state = 'error';
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'link underlined-link';
        retry.textContent = 'Yeniden dene';
        retry.addEventListener('click', () => location.reload());
        this.append(retry);
      } finally {
        clearTimeout(timer);
        if (this.isConnected) {
          root.removeAttribute('aria-busy');
          root.classList.remove('tays-stock-loading');
        }
      }
    }
    async span(base, availability, offset, count, size, expectedTotal) {
      const first = Math.floor(offset / size) + 1;
      const last = Math.floor((offset + count - 1) / size) + 1;
      const jobs = [];
      for (let page = first; page <= last; page++) {
        const url = new URL(base);
        url.hash = '';
        url.searchParams.set('filter.v.availability', availability);
        url.searchParams.set('page', page);
        url.searchParams.set('section_id', this.dataset.section);
        jobs.push(fetch(url, { signal: this.request.signal }).then(async response => {
          if (!response.ok) throw new Error('Section unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const metadata = doc.querySelector('tays-stock-first');
          const cards = [...doc.querySelectorAll('ul#product-grid > li')];
          if (Number(metadata?.dataset.total) !== expectedTotal || cards.some(card => card.dataset.productAvailable !== (availability === '1' ? 'true' : 'false'))) throw new Error('Stock data changed');
          return cards;
        }));
      }
      return (await Promise.all(jobs)).flat().slice(offset % size, offset % size + count);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
if (document.querySelector('.template-search')) {
  const url = new URL(location.href);
  const sort = url.searchParams.get('sort_by');
  const unavailable = url.searchParams.get('options[unavailable_products]');
  if ((sort && sort !== 'relevance') || (unavailable && unavailable !== 'last')) {
    url.searchParams.set('sort_by', 'relevance');
    url.searchParams.set('options[unavailable_products]', 'last');
    url.searchParams.delete('page');
    location.replace(url);
  }
}

  } catch(e) { console.error(e); }
})();
})();
